import * as React from 'react';

import EnterpriseOrgScopedLearningPathPageDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseOrgScopedLearningPathPageDataProvider';
import EnterpriseProgramAndMembershipDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseProgramAndMembershipDataProvider';
import SkillPathwayDataProvider from 'bundles/enterprise-learning-path-description-page/providers/SkillPathwayDataProvider';
import EnterpriseOrgScopedPageDataProvider from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgScopedPageDataProvider';
import EnterpriseOrgUserExperienceHandler from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgUserExperienceHandler';

const EnterpriseOrgScopedLearningPathDataProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseOrgScopedPageDataProvider>
      <EnterpriseOrgUserExperienceHandler>
        <EnterpriseOrgScopedLearningPathPageDataProvider>
          <EnterpriseProgramAndMembershipDataProvider>
            <SkillPathwayDataProvider>{children}</SkillPathwayDataProvider>
          </EnterpriseProgramAndMembershipDataProvider>
        </EnterpriseOrgScopedLearningPathPageDataProvider>
      </EnterpriseOrgUserExperienceHandler>
    </EnterpriseOrgScopedPageDataProvider>
  );
};

export default EnterpriseOrgScopedLearningPathDataProvider;
